module.exports = __webpack_public_path__ + "media/rise2.b14085cb.mp4";